import React, {useContext} from 'react';
import cx from 'classnames';
import {AISearchBlock} from '../../../../../../../_legacy/Searches/components/AISearch/parts/AISearchBlock/AISearchBlock';
import {AIFilterSearchContext} from './AIFilterSearch.context';
import styles from './styles.module.scss';

type Props = {
    handleAiSearch: (value: string) => void;
    showAISearch: () => void;
    filterCount: number;
};

export const AISection = (props: Props) => {
    const {handleAiSearch, showAISearch, filterCount} = props;
    const {aiSearchVisible, hasError, isEmptyResult, isLoading} = useContext(AIFilterSearchContext);

    return (
        <AISearchBlock
            componentClasses={cx(styles.component, styles.noHorizontalPadding)}
            showAiSearch={showAISearch}
            handleSearch={handleAiSearch}
            isLoading={isLoading}
            hasError={hasError}
            aiSearchVisible={aiSearchVisible}
            isEmptyResult={isEmptyResult && filterCount === 0}
        />
    );
};
